(function() {
  'use strict';

  var button = document.querySelector('[data-scroll-to-top]');
  if (!button) return;

  var threshold = parseInt(button.getAttribute('data-threshold'), 10) || 600;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ticking = false;

  button.hidden = false;

  function update() {
    ticking = false;
    button.classList.toggle('is-visible', window.pageYOffset > threshold);
  }

  window.addEventListener('scroll', function() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }, { passive: true });

  button.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  });

  update();
})();
